import React from 'react';
import { useIntl } from 'react-intl';

import { Dialog } from '@xingternal/dialog';

import styles from '../edit.css';

type DeleteDialogProps = {
  onConfirm: () => void;
  loading?: boolean;
  onCancel: () => void;
  showDialog: boolean;
};

const DeleteDialog = ({
  onConfirm,
  loading,
  onCancel,
  showDialog,
}: DeleteDialogProps) => {
  const intl = useIntl();
  return (
    <Dialog
      show={showDialog}
      className={styles.dialog}
      testId={'DELETE_DIALOG'}
      isDestructive={true}
      loading={loading}
      headline={intl.formatMessage({
        id: 'EP_DELETE_COVER_DIALOG_HEADLINE',
        defaultMessage: 'EP_DELETE_COVER_DIALOG_HEADLINE',
      })}
      text={intl.formatMessage({
        id: 'EP_DELETE_COVER_DIALOG',
        defaultMessage: 'EP_DELETE_COVER_DIALOG',
      })}
      cancelLabel={intl.formatMessage({
        id: 'EP_DELETE_COVER_DIALOG_KEEP',
        defaultMessage: 'EP_DELETE_COVER_DIALOG_KEEP',
      })}
      confirmLabel={intl.formatMessage({
        id: 'EP_DELETE_COVER_DIALOG_CONFIRM',
        defaultMessage: 'EP_DELETE_COVER_DIALOG_CONFIRM',
      })}
      onCancel={onCancel}
      onConfirm={onConfirm}
    />
  );
};

export default DeleteDialog;
